import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import FraudFactors from "./FraudFactors";
import FraudEntries from "./FraudEntries";
import FraudRecord from "./FraudRecord";
import { ShieldAlert } from "lucide-react";

export default function FraudCenter(props) {return <EngagementFraudCenter key={props.id} {...props}/>;}
function EngagementFraudCenter({ id }) {
  return (
    <div>
      <div className="bg-red-50 border border-red-200 rounded-sm p-2 mb-3 text-xs text-red-800 flex items-center gap-2">
        <ShieldAlert size={14} /> AI dapat membandingkan respons inkuiri, namun tidak boleh menyimpulkan seseorang melakukan kecurangan. Semua kesimpulan tetap penilaian auditor.
      </div>
      <Tabs defaultValue="register">
        <TabsList className="mb-3 flex-wrap h-auto">
          <TabsTrigger value="register" data-testid="fr-tab-register">Risk Register</TabsTrigger>
          <TabsTrigger value="inquiry" data-testid="fr-tab-inquiry">Fraud Inquiry</TabsTrigger>
          <TabsTrigger value="discussion">Team Discussion</TabsTrigger>
          <TabsTrigger value="conclusion">Fraud Conclusion</TabsTrigger>
          <TabsTrigger value="revenue" data-testid="fr-tab-revenue">Revenue Fraud</TabsTrigger>
          <TabsTrigger value="override" data-testid="fr-tab-override">Mgmt Override</TabsTrigger>
          <TabsTrigger value="factors">Risk Factors</TabsTrigger>
          <TabsTrigger value="cases">Cases</TabsTrigger>
          <TabsTrigger value="estimates">Estimate Review</TabsTrigger>
          <TabsTrigger value="sut">Unusual Transactions</TabsTrigger>
          <TabsTrigger value="schemes" data-testid="fr-tab-schemes">Scheme Library</TabsTrigger>
          <TabsTrigger value="exceptions" data-testid="fr-tab-exceptions">Exceptions</TabsTrigger>
        </TabsList>
        <TabsContent value="register"><FraudEntries id={id} kind="fraud-risks" /></TabsContent>
        <TabsContent value="inquiry"><FraudEntries id={id} kind="fraud-inquiries" /></TabsContent>
        <TabsContent value="discussion"><FraudRecord id={id} kind="fraud-discussion" /></TabsContent>
        <TabsContent value="conclusion"><FraudRecord id={id} kind="fraud-conclusion" /></TabsContent>
        <TabsContent value="revenue"><FraudRecord id={id} kind="revenue-fraud" /></TabsContent>
        <TabsContent value="override"><FraudRecord id={id} kind="management-override" /></TabsContent>
        <TabsContent value="factors"><FraudFactors id={id} /></TabsContent>
        <TabsContent value="cases"><FraudEntries id={id} kind="fraud-cases" /></TabsContent>
        <TabsContent value="estimates"><FraudEntries id={id} kind="estimate-bias" /></TabsContent>
        <TabsContent value="sut"><FraudEntries id={id} kind="sut" /></TabsContent>
        <TabsContent value="schemes"><Schemes id={id} /></TabsContent>
        <TabsContent value="exceptions"><Exceptions id={id} /></TabsContent>
      </Tabs>
    </div>
  );
}

function Schemes() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/meta/fraud`).then((r) => setRows(r.data.schemes)); }, []);
  return (
    <div className="bg-white border border-border rounded-sm overflow-x-auto"><table className="w-full audit-table">
      <thead><tr><th>Skema</th><th>Akun</th><th>Asersi</th><th>Prosedur</th></tr></thead>
      <tbody>{rows.map((s, i) => (<tr key={i} data-testid={`fr-scheme-${i}`}><td className="font-medium">{s.scheme}</td><td className="text-xs">{s.accounts}</td><td className="text-xs">{s.assertions}</td><td className="text-xs">{s.procedures}</td></tr>))}</tbody>
    </table></div>
  );
}

function Exceptions({ id }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/engagements/${id}/fraud-exceptions`).then((r) => setRows(r.data)); }, [id]);
  return (
    <div className="bg-white border border-border rounded-sm overflow-x-auto"><table className="w-full audit-table">
      <thead><tr><th>Sumber</th><th>Ref</th><th>Langkah</th><th>Catatan</th><th>Oleh</th></tr></thead>
      <tbody>{rows.map((r) => (<tr key={r.id} data-testid={`fr-exc-${r.id}`}><td>{r.source}</td><td className="font-mono text-xs">{r.ref}</td><td>{r.step}</td><td className="text-xs">{r.note}</td><td className="text-xs">{r.raised_by}</td></tr>))}
        {rows.length === 0 && <tr><td colSpan={5} className="text-center text-muted-foreground py-4">Belum ada eksepsi fraud (dieskalasi dari JET).</td></tr>}</tbody></table></div>
  );
}
